import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Virginia Grapes · Taste the Tradition</p>
        <h1>Discover the Rich Flavors of Virginia Grapes</h1>
        <p className="lede">
          Experience the essence of Virginia's vineyards. Our selection of locally sourced grapes brings the taste of tradition to your table. Explore our offerings and elevate your culinary creations.
        </p>
        <div className="cta-row">
          <a href="/products" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Fresh from the Vine</h2>
          <p>
            Our grapes are handpicked from the finest vineyards in Virginia, ensuring quality and freshness in every bite.
          </p>
        </article>
        <article>
          <h2>Perfect for Every Occasion</h2>
          <p>
            Whether you're hosting a dinner party or enjoying a quiet evening at home, our grapes are the perfect addition to any meal.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Sign up for our newsletter to receive updates on new arrivals, exclusive offers, and tips for enjoying Virginia grapes.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;